import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AuthGate from './AuthGate';
import { unregister } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthGate>
    <App />
  </AuthGate>
);

// Unregister any previously installed service worker.
// This trading app has no offline requirement and a stale SW
// causes users to see old bundles after deployments.
unregister();
